const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentHeroDeluxe extends HTMLDivElement {

	static isVideoPlaying(video) {
		if (video.currentTime > 0
		&& !video.paused
		&& !video.ended
		&& video.readyState > 2) {
			return true
		}
		return false;
	};


	constructor() {
		super();
	}
	async connectedCallback() {
		await childrenLoaded(this);
		// console.log(this);
		if (this.videoElement) {
			this.playPauseButtonElement.addEventListener('click', this.playPauseClickHandler);
		}
		this.updateAngleSize();
		window.addEventListener('resize', () => {
			this.updateAngleSize();
		});
	}
	
	updateAngleSize() {
		const contentElement2 = this.querySelector('.component-hero-deluxe__text-content-area-container-2');
		const contentElement3 = this.querySelector('.component-hero-deluxe__text-content-area-container-3');

		const largeMQ = window.matchMedia('(max-width: 80rem)');
		const mediumMQ = window.matchMedia('(max-width: 48rem)');

		this.previousMQ = 'max-width';
		let element3Width = '660px';
		if (largeMQ.matches) {
			this.previousMQ = 'large';
			element3Width = '600px';
		}
		if (this.previousMQ !== 'medium' && mediumMQ.matches) {
			this.previousMQ = 'medium';
			contentElement2.style.removeProperty('clip-path');
			contentElement2.style.removeProperty('padding-right');
			contentElement3.style.removeProperty('width');
			return;
		}

		const contentHeight = contentElement2.getBoundingClientRect()['height'];
		// desired angle ratio: 425/106
		const angleWidth = `${contentHeight * 106 / 425}px`;
		contentElement2.style.setProperty('clip-path', `polygon(0 0, 100% 0, calc(100% - ${angleWidth}) 100%, 0 100%)`);
		contentElement2.style.setProperty('padding-right', `${angleWidth}`);
		contentElement3.style.setProperty('width', `calc(${element3Width} + ${angleWidth})`);

		if (!this.classList.contains('initialized')) {
			this.classList.add('initialized');
		}
	}

	get videoElement() {
		return this.querySelector('.component-hero-deluxe__background video');
	}

	get playPauseButtonElement() {
		return this.querySelector('.component-hero-deluxe__background button');
	}

	pauseVideo() {
		if (this.videoElement) {
			this.videoElement.pause();
			this.playPauseButtonElement.setAttribute('aria-label', 'play video');
		}
	}

	playVideo() {
		if (this.videoElement) {
			this.videoElement.play();
			this.playPauseButtonElement.setAttribute('aria-label', 'pause video');
		}
	}

	playPauseClickHandler = () => {
		if (this.constructor.isVideoPlaying(this.videoElement)) {
			this.pauseVideo();
		}
		else {
			this.playVideo();
		}
	}

}

customElements.define('component-hero-deluxe', ComponentHeroDeluxe, {extends: 'div'});